'use client';
import HubHandoffLink from '@dr-pam/common-components/Components/Auth/HubHandoffLink';
import React from 'react';
import Link from 'next/link';
import DropDownTextMenu from './navbar/DropDownTextMenu';

export type ProfessionalsMenuProps = {
	active: boolean;
	onToggle: () => void;
	onNavigate: () => void;
	ndcHubUrl?: string;
	/** Members get the calendar and guest speakers in "my possums" and the hub login as a navbar button instead. */
	coursesOnly?: boolean;
};

export default function ProfessionalsMenu({
	active,
	onToggle,
	onNavigate,
	ndcHubUrl,
	coursesOnly = false,
}: ProfessionalsMenuProps) {
	return (
		<DropDownTextMenu title="for providers" active={active} onToggle={onToggle}>
			<div className={`professionals-menu${coursesOnly ? ' professionals-menu--courses-only' : ''}`}>
				{!coursesOnly && (
					<>
						<div className="professionals-menu__col">
							<Link
								className="nav-link professional-nav-link"
								href="/ndc-institute"
								onClick={onNavigate}
								style={{ paddingTop: 15 }}
							>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img src="/images/icons/dark-icons/TheNdcInstitute.svg" height={30} width={30} alt="" />
								<div>
									<span className="nav-link-main">possums for providers</span>
									<br />
									<span className="nav-link-sub">(the ndc institute)</span>
								</div>
							</Link>
							<Link className="nav-link" href="/ndc-institute/calendar" onClick={onNavigate}>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img src="/images/icons/dark-icons/CalendarEvents.svg" height={30} width={30} alt="" />
								ndc institute calendar
							</Link>
							<Link className="nav-link" href="/ndc-institute/guest-speaker-events" onClick={onNavigate}>
								{/* eslint-disable-next-line @next/next/no-img-element */}
								<img src="/images/icons/dark-icons/GuestSpeakers.svg" height={30} width={30} alt="" />
								guest speaker events
							</Link>

							{ndcHubUrl && (
								<HubHandoffLink
									className="nav-link"
									hubUrl={ndcHubUrl}
									target="_blank"
									rel="noreferrer"
									onClick={onNavigate}
								>
									{/* eslint-disable-next-line @next/next/no-img-element */}
									<img
										src="/images/icons/dark-icons/login-icon_dark.svg"
										height={30}
										width={30}
										alt=""
									/>
									education hub login
								</HubHandoffLink>
							)}
						</div>

						<div className="professionals-menu__divider" aria-hidden />
					</>
				)}

				<div className="professionals-menu__col">
					<p className="professionals-menu__section-header">courses for registered health professionals:</p>
					<Link
						className="nav-link"
						href="/ndc-institute/masterclasses-accreditation-pathway"
						onClick={onNavigate}
					>
						{/* eslint-disable-next-line @next/next/no-img-element */}
						<img src="/images/icons/ndc-icons/course_icon_dark-blue.svg" height={30} width={30} alt="" />
						<div>
							<span className="nav-link-main">ndc masterclasses and</span>
							<br />
							<span className="nav-link-sub">accreditation</span>
						</div>
					</Link>
					<Link className="nav-link" href="/ndc-institute/lactation-fellowship" onClick={onNavigate}>
						{/* eslint-disable-next-line @next/next/no-img-element */}
						<img src="/images/icons/ndc-icons/course_icon_dark-blue.svg" height={30} width={30} alt="" />
						ndc lactation fellowship
					</Link>
				</div>

				<div className="professionals-menu__divider" aria-hidden />

				<div className="professionals-menu__col">
					<p className="professionals-menu__section-header">courses for providers and educators:</p>
					<Link className="nav-link" href="/ndc-institute/providers-educators-pathway" onClick={onNavigate}>
						{/* eslint-disable-next-line @next/next/no-img-element */}
						<img src="/images/icons/ndc-icons/course_icon_dark-blue.svg" height={30} width={30} alt="" />
						<div>
							<span className="nav-link-main">ndc providers and educators</span>
						</div>
					</Link>
					<p className="professionals-menu__section-header professionals-menu__section-header--sub">
						extra learning
					</p>
					<Link className="nav-link" href="/ndc-institute/sleep-baby-and-you" onClick={onNavigate}>
						{/* eslint-disable-next-line @next/next/no-img-element */}
						<img src="/images/icons/ndc-icons/course_icon_dark-blue.svg" height={30} width={30} alt="" />

						<div>
							<span className="nav-link-main">sleep, baby, and you</span>
							<br />
							<span className="nav-link-sub">course with helen ball</span>
						</div>
					</Link>
				</div>
			</div>
		</DropDownTextMenu>
	);
}
